import { useParams } from 'react-router-dom'

import { PostComposer } from '@tribeplatform/react-components/PostComposer'
import { PostList } from '@tribeplatform/react-components/PostList'
import { useSpace } from '@tribeplatform/react-sdk/hooks'
import { EmbeddedSpaceHeader } from '@tribeplatform/react-slate-kit/components'

import { useQuery } from '../../hooks/useQuery.js'
import { EmbedProvider } from '../EmbedProvider.js'
import { withEmbedRouteChangeHandler } from '../withEmbedRouteChangeHandler.js'

export const SpaceEmbed = withEmbedRouteChangeHandler(() => {
  const params = useParams()
  const query = useQuery()
  const { slug } = params
  const { data: space } = useSpace({
    variables: {
      slug,
    },
  })

  if (!space) {
    return null
  }

  const {
    view = 'card',
    readonly = 'false',
    tag_id: tagId,
    tag: tagSlug,
  } = query || {}

  const header = query.header === 'true'
  const composer = query.composer === 'true'
  const values = {
    readonly: readonly === 'true',
    postView: view === 'row' ? 'row' : 'card',
  }

  return (
    <EmbedProvider values={values}>
      <div className="bg-background">
        {header && (
          <div className="mb-5">
            <EmbeddedSpaceHeader spaceId={space.id} />
          </div>
        )}
        <div className="grid grid-cols-12 gap-5">
          <div className="web:col-span-12">
            {composer && (
              <>
                <PostComposer space={space} />
                <div className="mt-5" />
              </>
            )}
            <PostList spaceId={space.id} tagId={tagId} tagSlug={tagSlug} />
          </div>
        </div>
      </div>
    </EmbedProvider>
  )
})
